function getDeviceWidth() {
  if (typeof window === 'undefined') return null
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0
}

function isDesktopVP() {
  const deviceWidth = getDeviceWidth()
  return Boolean(!!deviceWidth && deviceWidth >= 1024)
}

export { getDeviceWidth, isDesktopVP }
